import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { reduxForm, Field, getFormValues } from "redux-form";

import ContentCard from "../common/template/contentCard";
import ContentCardHeader from "../common/template/contentCardHeader";
import ContentCardBody from "../common/template/contentCardBody";
import ContentCardFooter from "../common/template/contentCardFooter";
import Row from "../common/layout/row";
import Grid from "../common/layout/grid";
import Button from "../common/button/button";
import Form from "../common/form/form";
import LabelAndInput from "../common/form/labelAndInput";
import LabelAndInputNumber from "../common/form/labelAndInputNumber";
import LabelAndInputMask from "../common/form/labelAndInputMask";
import Select from "../common/form/select";
import FaturaItem from "./faturaItem/faturaItem";
import { ModalForm } from "../common/dialog/modalForm";
import {
    setModoTela,
    initForm,
    setImportacaoValidada,
    setEngenhariaValidada,
    alterarAliquotaIcmsImportada,
    alterarValorIcmsImportado,
    getListaFaturasAdm,
    getListaFaturasEngenharia,
    buscarAnexoRefaturamento,
} from "./faturaActions";
import ButtonTable from "../common/table/buttonTable";
import { setArquivoPDF } from "../displayPDF/displayPDFActions";

const INITIAL_STATE = {
    exibirModalAliquotaIcms: false,
    exibirModalValorIcms: false,
    recarregarListaAoSair: false,
};

function FaturaForm(props) {
    const [state, setState] = useState(INITIAL_STATE);

    useEffect(() => {
        return () => props.setModoTela("lista");
    }, []);

    let usuarioFaturaEdicao = props.usuarioLogado && (props.usuarioLogado.acesso_fatura_editar || props.usuarioLogado.acesso_fatura_editar_fechado);
    let usuarioMultaEdicao = props.usuarioLogado && (props.usuarioLogado.acesso_multa_editar || props.usuarioLogado.acesso_multa_editar_fechado);

    let readOnly = props.visualizar || props.excluir || props.formularioValues.importacao_validada || props.engenharia || !usuarioFaturaEdicao;

    return (
        <div>
            {state.exibirModalAliquotaIcms ? (
                <ModalForm
                    titulo="Alterar a alíquota do ICMS(%) importada"
                    item={{
                        ...props.formularioValues,
                        icms_importado: String(props.formularioValues.icms_importado | 0).replace(".", ","),
                    }}
                    handleSubmit={(fatura) => {
                        props.alterarAliquotaIcmsImportada(fatura, () => setState({ exibirModalAliquotaIcms: false, recarregarListaAoSair: true }));
                    }}
                    handleClose={() => setState({ exibirModalAliquotaIcms: false })}
                >
                    <LabelAndInputNumber
                        name="icms_importado"
                        label="Alíquota do ICMS importada(%)"
                        placeholder="Informe a alíquota do ICMS (%)"
                        cols="12 12 12 12"
                        casas={2}
                        allowNegative={false}
                    />
                </ModalForm>
            ) : null}
            {state.exibirModalValorIcms ? (
                <ModalForm
                    titulo="Alterar o valor do ICMS(R$) importado"
                    item={{
                        ...props.formularioValues,
                        valor_icms: String(props.formularioValues.valor_icms | 0).replace(".", ","),
                    }}
                    handleSubmit={(fatura) => {
                        props.alterarValorIcmsImportado(fatura, () => setState({ exibirModalValorIcms: false, recarregarListaAoSair: true }));
                    }}
                    handleClose={() => setState({ exibirModalValorIcms: false })}
                >
                    <LabelAndInputNumber
                        name="valor_icms"
                        label="Valor do ICMS importado(R$)"
                        placeholder="Informe o valor do ICMS (R$)"
                        cols="12 12 12 12"
                        casas={2}
                        allowNegative={false}
                    />
                </ModalForm>
            ) : null}
            <ContentCard>
                {/*ALERTAS*/}
                {(props.formularioValues.erros_importacao || []).map((erro) => (
                    <div key={erro.mensagem} className={`alert alert-${props.formularioValues.importacao_validada ? "warning" : "danger"} alert-dismissible`}>
                        <h6>Importação</h6>
                        {erro.mensagem}
                    </div>
                ))}
                {props.engenharia
                    ? (props.formularioValues.erros_engenharia || []).map((erro) => (
                          <div className={`alert alert-${props.formularioValues.engenharia_validada ? "warning" : "danger"} alert-dismissible`}>
                              <h6>Engenharia</h6>
                              {erro.mensagem}
                          </div>
                      ))
                    : null}

                {props.formularioValues && props.formularioValues.id ? (
                    <ContentCardHeader>
                        <Row>
                            {/*
							<Grid cols='6 6 4 2'>
								<Button
									text='Imprimir'
									type={'primary'}
									icon={'fa fa-plus'}
									event={() => {
										props.setModoTela('relatorio', {
											...props.formularioValues,
											cliente: props.listaCliente.filter(item => item.id == props.formularioValues.id_cliente)[0],
											unidadeConsumidora: props.listaUnidadeConsumidora.filter(item => item.id == props.formularioValues.id_unidade_consumidora)[0]
										});
									}} />
							</Grid>
							*/}
                            {/*Validar Importação*/}
                            {!props.engenharia && !props.formularioValues.importacao_validada ? (
                                <Grid cols="6 6 4 2">
                                    <Button
                                        text="Validar e Fechar"
                                        type={"success"}
                                        icon={"fa fa-check"}
                                        disabled={props.visualizar || !usuarioFaturaEdicao}
                                        event={() => {
                                            props.setImportacaoValidada({
                                                ...props.formularioValues,
                                                importacao_validada: true,
                                            });
                                        }}
                                    />
                                </Grid>
                            ) : !props.engenharia && props.formularioValues.importacao_validada ? (
                                <Grid cols="6 6 4 2">
                                    <Button
                                        text="Reabrir"
                                        type={"danger"}
                                        icon={"fa fa-unlock"}
                                        //só editar fechado pode reabrir
                                        disabled={props.visualizar || !props.usuarioLogado || !props.usuarioLogado.acesso_fatura_editar_fechado}
                                        event={() => {
                                            props.setImportacaoValidada({
                                                ...props.formularioValues,
                                                importacao_validada: false,
                                            });
                                        }}
                                    />
                                </Grid>
                            ) : null}

                            {/*Validar Engenharia*/}
                            {props.engenharia && props.formularioValues.importacao_validada && !props.formularioValues.engenharia_validada ? (
                                <Grid cols="6 6 4 2">
                                    <Button
                                        text="Validar e Fechar"
                                        type={"success"}
                                        icon={"fa fa-check"}
                                        disabled={!usuarioMultaEdicao}
                                        event={() => {
                                            props.setEngenhariaValidada({
                                                ...props.formularioValues,
                                                engenharia_validada: true,
                                            });
                                        }}
                                    />
                                </Grid>
                            ) : props.engenharia && props.formularioValues.importacao_validada && props.formularioValues.engenharia_validada ? (
                                <Grid cols="6 6 4 2">
                                    <Button
                                        text="Reabrir"
                                        type={"danger"}
                                        icon={"fa fa-unlock"}
                                        //só editar fechado pode reabrir
                                        disabled={!props.usuarioLogado || !props.usuarioLogado.acesso_multa_editar_fechado}
                                        event={() => {
                                            props.setEngenhariaValidada({
                                                ...props.formularioValues,
                                                engenharia_validada: false,
                                            });
                                        }}
                                    />
                                </Grid>
                            ) : null}
                        </Row>
                    </ContentCardHeader>
                ) : null}
                <Form event={props.handleSubmit}>
                    <ContentCardBody>
                        <Row>
                            <Field
                                name="id_cliente"
                                component={Select}
                                //se usuario implantacao estiver logado
                                //filtra para poder incluir apenas itens na UC
                                //que ele é o implantador
                                options={
                                    props.usuarioLogado.usuario_implantacao
                                        ? props.listaCliente.filter((cliente) => cliente.itens.find((uc) => uc.id_usuario_implantacao == props.usuarioLogado.id))
                                        : props.listaCliente
                                }
                                label="Cliente"
                                cols="12 12 12 12"
                                placeholder="Selecione o cliente"
                                readOnly={readOnly}
                            />
                        </Row>
                        <Row>
                            <Field
                                name="id_unidade_consumidora"
                                component={Select}
                                //se usuario implantacao estiver logado
                                //filtra para poder incluir apenas itens na UC
                                //que ele é o implantador
                                options={props.listaUnidadeConsumidora.filter((item) => {
                                    const implantacaoLogado = props.usuarioLogado.usuario_implantacao;
                                    const ucClienteSelecionado = item.id_cliente == props.formularioValues.id_cliente;
                                    if (implantacaoLogado) {
                                        const usuarioImplantacaoVinculadoUc = item.id_usuario_implantacao == props.usuarioLogado.id;
                                        return usuarioImplantacaoVinculadoUc && ucClienteSelecionado;
                                    }
                                    return ucClienteSelecionado;
                                })}
                                label="Unidade Consumidora"
                                cols="12 12 12 12"
                                placeholder="Selecione a unidade consumidora"
                                readOnly={readOnly}
                            />
                        </Row>
                        <Row>
                            <Field
                                name="competencia"
                                component={LabelAndInputMask}
                                label="Competência"
                                placeholder="Informe a competência"
                                cols="12 12 12 12"
                                mask="99/9999"
                                readOnly={readOnly}
                            />
                        </Row>
                        <Row>
                            <Field
                                name="observacao_importacao"
                                component={LabelAndInput}
                                label="Observação da análise de importação"
                                placeholder="Informe a observação da análise de importação"
                                cols="12 12 12 12"
                                readOnly={readOnly}
                            />
                        </Row>
                        <Row>
                            <LabelAndInputNumber
                                name="valor_fatura"
                                label="Valor Importado da Fatura"
                                placeholder="Informe o valor importado da fatura"
                                cols="12 12 4 3"
                                casas={2}
                                readOnly={!props.formularioValues.id || readOnly}
                                value={props.formularioValues.valor_fatura}
                                onChange={(data) => {
                                    props.initForm({
                                        ...props.formularioValues,
                                        valor_fatura: data.target.value,
                                    });
                                }}
                            />
                            {props.formularioValues.id && props.formularioValues.refaturada ? (
                                <Grid cols="12 12 8 6" style={{ paddingInline: 15 }}>
                                    <div>
                                        <label className="mr-2">Anexo Refaturamento</label>
                                    </div>

                                    <Row>
                                        <ButtonTable
                                            style={{ margin: 0, marginLeft: 8 }}
                                            title="Visualizar Anexo do Refaturamento"
                                            type={"primary"}
                                            icon={"fas fa-file-pdf"}
                                            disabled={!props.formularioValues.anexo_refaturamento}
                                            visible={true}
                                            event={() => {
                                                props.buscarAnexoRefaturamento(props.formularioValues.id);
                                                props.setArquivoPDF();
                                            }}
                                        />
                                    </Row>
                                </Grid>
                            ) : null}
                        </Row>
                        {props.formularioValues.importacao_validada ? (
                            <Row>
                                <Field
                                    name="observacao_engenharia"
                                    component={LabelAndInput}
                                    label="Observação da análise de engenharia"
                                    placeholder="Informe a observação da análise de engenharia"
                                    cols="12 12 12 12"
                                    readOnly={!props.engenharia || props.formularioValues.engenharia_validada}
                                />
                            </Row>
                        ) : null}
                    </ContentCardBody>
                    {props.modoTelaFaturaItem === "lista" ? (
                        <ContentCardFooter style={{ backgroundColor: "#FFFFFF" }}>
                            <Row alignCenter>
                                {props.excluir ? (
                                    <Grid cols="6 6 4 3">
                                        <Button
                                            text="Excluir"
                                            submit
                                            type={"danger"}
                                            disabled={props.formularioValues.importacao_validada || props.engenharia || !usuarioFaturaEdicao}
                                            icon={"fa fa-trash"}
                                        />
                                    </Grid>
                                ) : !props.engenharia ? (
                                    <Grid cols="6 6 4 3">
                                        <Button
                                            text="Salvar"
                                            submit
                                            disabled={props.visualizar || props.formularioValues.importacao_validada || !usuarioFaturaEdicao}
                                            type={"success"}
                                            icon={"fa fa-check"}
                                        />
                                    </Grid>
                                ) : null}

                                <Grid cols="6 6 4 3">
                                    <Button
                                        text="Voltar"
                                        type={"warning"}
                                        icon={"fa fa-chevron-left"}
                                        event={() => {
                                            props.setModoTela("lista");
                                            if (state.recarregarListaAoSair) {
                                                if (props.engenharia) {
                                                    props.getListaFaturasEngenharia();
                                                } else {
                                                    props.getListaFaturasAdm();
                                                }
                                            }
                                        }}
                                    />
                                </Grid>
                            </Row>
                        </ContentCardFooter>
                    ) : null}
                </Form>

                <FaturaItem
                    aliquotaIcmsDivergente={props.formularioValues.icms_esperado !== props.formularioValues.icms_importado}
                    exibirModalAliquotaIcms={() => setState({ exibirModalAliquotaIcms: true })}
                    exibirModalValorIcms={() => setState({ exibirModalValorIcms: true })}
                    engenharia={props.engenharia}
                />
            </ContentCard>
        </div>
    );
}

const FaturaFormRedux = reduxForm({ form: "faturaForm", destroyOnUnmount: false })(FaturaForm);
const mapStateToProps = (state) => ({
    sessao: state.auth.usuario,
    usuarioLogado: state.auth.usuarioLogado,
    modoTelaFaturaItem: state.faturaItem.modoTela,
    formularioValues: getFormValues("faturaForm")(state),
    aguardando: state.fatura.aguardando,
    registro: state.fatura.registro,
    listaCliente: state.fatura.listaCliente,
    listaUnidadeConsumidora: state.fatura.listaUnidadeConsumidora,
});
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setModoTela,
            initForm,
            getListaFaturasAdm,
            getListaFaturasEngenharia,
            setImportacaoValidada,
            setEngenhariaValidada,
            alterarAliquotaIcmsImportada,
            alterarValorIcmsImportado,
            buscarAnexoRefaturamento,
            setArquivoPDF,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(FaturaFormRedux);
